/**
 * =============================================================================
 * gtag.js 
 * =============================================================================
 * GA4 gtag helper
 * =============================================================================
 */

var GtagHelper = {
  selectors: {
    emitter: "[data-gtag-event]",
  },

  init: function() {
    document.querySelectorAll(this.selectors.emitter).forEach(element => {
      let gtagEventName = element.dataset.gtagEvent;
      let gtagEventParametersString = element.dataset.gtagEventParameters;

      if(!gtagEventName || !gtagEventParametersString){
        return;
      }
      let gtagEventParameters = false;
      try {
        gtagEventParameters = JSON.parse(gtagEventParametersString);
      } catch (error) {
        console.warn(error);
      }

      element.addEventListener("click", event => {
        if(gtag){
          console.log('[G-H]', 'Trigger gtag!', gtagEventName, gtagEventParameters);
          gtag("event", gtagEventName, gtagEventParameters);
        }
      });
    });
  }
};

export default GtagHelper;